const map = {
	"./ashcastillo_card_snowup.png": 545,
	"./gp_screenshot_phne_2.png": 751,
	"./imagen_card_BubbleTap.jpg": 922,
	"./imagen_card_BubbleTap.png": 302,
	"./imagen_card_Cardiorhythm.png": 981,
	"./imagen_card_SnowUp.png": 233,
	"./imagen_card_YingYangFish.png": 49
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;